/** 从 API 响应中解析对外 publicId（兼容 publicId / public_id / id） */
export function resolveWirePublicId(
  source: object | null | undefined,
  ...keys: string[]
): string {
  if (!source || typeof source !== 'object') return ''
  const record = source as Record<string, unknown>
  for (const key of keys) {
    const value = String(record[key] ?? '').trim()
    if (value) return value
  }
  return ''
}

const DEFAULT_REJECTED = new Set(['undefined', 'null'])

/** 路由/API 入参：拒绝空值与字面量 "undefined" / "null" */
export function isValidPublicId(
  value: string | null | undefined,
  options?: { extraRejected?: string[] },
): boolean {
  const trimmed = String(value ?? '').trim()
  if (!trimmed) return false
  const rejected = options?.extraRejected
    ? new Set([...DEFAULT_REJECTED, ...options.extraRejected])
    : DEFAULT_REJECTED
  return !rejected.has(trimmed)
}
